<template>
  <div><component :is="logoComponent" class="equestrian-logo" /></div>
</template>
<script>
import { defineComponent } from "vue";
import AppEquestrianDefaultLogo from "./EquestrianLogos/AppEquestrianDefaultLogo.vue";
export default defineComponent({
  name: "AppEquastrianLogo",
  components: {
    AppEquestrianBelgiumLogo: () =>
      import("./EquestrianLogos/AppEquestrianBelgiumLogo.vue"),
    AppEquestrianDefaultLogo
  },
  computed: {
    logoComponent() {
      switch (this.$federation.countryCode) {
        case "BE":
          return "AppEquestrianBelgiumLogo";
        default:
          return "AppEquestrianDefaultLogo";
      }
    }
  }
});
</script>
<style lang="scss">
.equestrian-logo {
  .logo-space-width {
    width: 133px;
    margin-right: 23px;
  }

  .large-logo {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
    z-index: 100;
    width: 100px;
    height: 100px;
    padding: 13px;
    img {
      width: 75px;
      height: 75px;
    }
  }
  .small-logo-wrapper {
    & {
      padding: 0px 8px;
      height: 48px;
      display: flex;
    }
    img {
      margin: auto;
      max-width: 100%;
      display: block;
      height: 39px;
    }
  }
}
</style>
